import { Component, Vue, Prop } from 'vue-property-decorator';
import { TEXTFIELD_BUTTON_ACTION_TYPES } from '@/models/enums/textfield-button-action-types.enum';
import { TextfieldValue } from '@/models/survey-elements/textfield-value';
import { EventBus } from '@/event-bus';
import { SurveyElementsUnion } from '@/models/survey-elements-union';
import Header from '@/components/Header.vue';
import { ActionButton } from '@/models/action-button';
import { WIDGET_EVENTS } from '@/const/widget-events';

@Component({
  components: {
    Header,
    Button: () => import('@/components/Button.vue'),
  },
})
export default class TextFieldElementMixin extends Vue {
  @Prop({ type: Object, default: () => null })
  actionButton!: ActionButton | null;
  @Prop({ type: Object }) field?: SurveyElementsUnion;
  @Prop({ type: String, default: () => null }) title!: string | null;
  @Prop({ type: String }) text!: string;
  @Prop({ type: String }) externalApiIdentifier!: string | null;
  @Prop({ type: String }) value!: string | null;
  @Prop({ type: Boolean, default: false }) center!: boolean;

  private get fieldValue(): string | null {
    return this.value;
  }

  private async copyAndGoToMaps(value: string) {
    this.$store.dispatch('setReviewText', value);
    await navigator.clipboard.writeText(value);
  }

  private submitHandler() {
    EventBus.$emit(WIDGET_EVENTS.SUBMIT, {
      field: this.field,
      value: this.value || null,
    });
  }

  private async actionHandler(value: string) {
    if (
      this.actionButton?.action === TEXTFIELD_BUTTON_ACTION_TYPES.GO_TO_MAPS
    ) {
      await this.copyAndGoToMaps(value);
    }
    this.submitHandler();
  }

  created() {
    if (!this.externalApiIdentifier) return;
    const externalApiIdentifier = this.$route.query[this.externalApiIdentifier];
    if (externalApiIdentifier) {
      EventBus.$emit(WIDGET_EVENTS.CHANGE, {
        field: this.field,
        value: externalApiIdentifier,
      });
    }
  }
}
